export function sanitizeName(name: string) {
  return name.replaceAll(/[^a-zA-Z0-9]/g, '').toLowerCase();
}
